import { Container, Row, Col, Card } from "react-bootstrap";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from "lucide-react";

const ContactSection = () => {
  return (
    <section id="contato" className="py-5">
      <Container className="py-5">
        {/* Header */}
        <div className="text-center mb-5">
          <span className="d-inline-block text-primary-custom fw-semibold mb-3">
            Contato
          </span>
          <h2 className="display-6 fw-bold mb-3">
            Entre em contato conosco
          </h2>
          <p className="text-muted-custom mx-auto" style={{ maxWidth: "600px" }}>
            Estamos prontos para atendê-lo. Entre em contato por qualquer um dos nossos canais.
          </p>
        </div>

        {/* Contact Cards */}
        <Row className="g-4 justify-content-center mb-5">
          {/* Address */}
          <Col sm={6} lg={3}>
            <Card className="card-custom shadow-card h-100 p-4 text-center">
              <Card.Body>
                <div className="icon-box bg-secondary-custom mx-auto mb-3">
                  <MapPin size={28} className="text-primary-custom" />
                </div>
                <h5 className="fw-semibold mb-2">Endereço</h5>
                <p className="text-muted-custom small mb-0">
                  Rua das Flores, 123<br />
                  Centro - São Paulo, SP
                </p>
              </Card.Body>
            </Card>
          </Col>

          {/* Phone */}
          <Col sm={6} lg={3}>
            <Card className="card-custom shadow-card h-100 p-4 text-center">
              <Card.Body>
                <div className="icon-box bg-secondary-custom mx-auto mb-3">
                  <Phone size={28} className="text-primary-custom" />
                </div>
                <h5 className="fw-semibold mb-2">Telefone</h5>
                <p className="text-muted-custom small mb-0">
                  (11) 99999-9999<br />
                  WhatsApp disponível
                </p>
              </Card.Body>
            </Card>
          </Col>

          {/* Email */}
          <Col sm={6} lg={3}>
            <Card className="card-custom shadow-card h-100 p-4 text-center">
              <Card.Body>
                <div className="icon-box bg-secondary-custom mx-auto mb-3">
                  <Mail size={28} className="text-primary-custom" />
                </div>
                <h5 className="fw-semibold mb-2">E-mail</h5>
                <p className="text-muted-custom small mb-0">
                  contato@agendafacil.com<br />
                  Resposta em até 24h
                </p>
              </Card.Body>
            </Card>
          </Col>

          {/* Hours */}
          <Col sm={6} lg={3}>
            <Card className="card-custom shadow-card h-100 p-4 text-center">
              <Card.Body>
                <div className="icon-box bg-secondary-custom mx-auto mb-3">
                  <Clock size={28} className="text-primary-custom" />
                </div>
                <h5 className="fw-semibold mb-2">Horário</h5>
                <p className="text-muted-custom small mb-0">
                  Seg - Sáb: 9h às 18h<br />
                  Domingo: Fechado
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Social Media */}
        <div className="d-flex justify-content-center gap-3">
          <a href="#" className="social-icon">
            <Instagram size={20} />
          </a>
          <a href="#" className="social-icon">
            <Facebook size={20} />
          </a>
        </div>
      </Container>
    </section>
  );
};

export default ContactSection;